import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Action from '@components/Action'
import Download from '@components/Icon/Download'

class Actions extends Component {
  static propTypes = {
    date: PropTypes.string
  }

  render() {
    return (
      <ul className="actions right-list">
        <li
          className="action"
          onClick={() => {
            this.props.revenuesStore.exportReport({
              export: 'accounting',
              queueProcessorStore: this.props.queueProcessorStore
            })
          }}>
          <Action>
            <Download />
            <span>Accounting export</span>
          </Action>
        </li>
        <li className="action">
          <Action
            onClick={() => {
              this.props.revenuesStore.exportReport({
                export: 'regular',
                queueProcessorStore: this.props.queueProcessorStore
              })
            }}>
            <Download />
            <span>Export</span>
          </Action>
        </li>
      </ul>
    )
  }
}

export default inject('revenuesStore', 'queueProcessorStore')(observer(Actions))
